// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content--0p2gGez clearfix"};